<template>
  <ul class="nav">
    <li class="nav-item" v-for="item in linksList" :id="item.routeName" :key="item.path">
        <AppIcon class="nav-item-icon" :iconName="item.icon" :id="item.routeName"/>
        <p class="nav-item-text" :id="item.routeName">{{ item.name }}</p>
    </li>
  </ul>
</template>

<script>
import AppIcon from "./AppIcon.vue";

export default {
  name: "AppBottomNav",
  props: {
    linksList: Array
  },
  components: {
    AppIcon
  },
  mounted() {
    this.styleActiveLink();
  },
  methods: {
    styleActiveLink() {
      const currentRoute = this.$route.name;

      const navItems = document.querySelectorAll(".nav-item");

      navItems.forEach(item => {
        if (item.id === currentRoute) item.classList.toggle("router-link-exact-active");
        else item.classList.remove("router-link-exact-active");
      });
    }
  }
};
</script>

<style scoped>
.nav {
  background-color: var(--color-white);
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  padding: 0.8rem;
  align-items: center;
  justify-content: space-around;
  filter: drop-shadow(0 -1px 2px rgba(0, 0, 0, 0.1));
  user-select: none;
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  user-select: none;
}

.nav-item-icon {
  fill: var(--color-tertiary);
}

.nav-item-text {
  color: var(--color-tertiary);
  font-size: 0.85rem;
}

.nav-item.router-link-exact-active .nav-item-text {
  color: var(--color-primary);
  font-weight: 600;
}

.nav-item.router-link-exact-active .nav-item-icon {
  fill: var(--color-primary);
}
</style>
